import 'bootstrap/dist/css/bootstrap.min.css';
import React, { lazy, useContext, useEffect, useState } from 'react';
import { Accordion, Alert, Badge, Button, Carousel, CloseButton, Col, Container, FloatingLabel, Form, Image, InputGroup, NavDropdown, Row, Tab, Tabs, Toast } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { LanguageCtx, LoginInfo } from '../App';
import { followDelete, followPost } from '../service/FollowService';
import ApiFetch from './ApiFetch';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import parse, { domToReact } from 'html-react-parser'
import { isLoggin, login, updateRenzoku, updateTile } from '../service/LoginService';
import { t } from 'i18next';
import i18n from '../i18n/config';
import UserInfoPopup from './common/UserInfoPopup';
import FollowButton from './FollowButton';
import QuestionAnswer from './QuestionAnswer';
import EditPopup from './EditPopup';
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import RegistOrLogin from './RegistOrLogin';
import { mutePost } from '../service/MuteService';
import MuteButton from './MuteButton';
import Report from './Report';
import UserManageInfo from './UserManageInfo';
import PointSend from './PointSend';
import Comment from './Comment';
import Reply from './Reply';
import { Typeahead } from 'react-bootstrap-typeahead';
import FavoriteIconV2 from './FavoriteIconV2';
import UserMark from './UserMark';
import UserAvatarWithLikes from './UserAvatarWithLikes';
import TextReader from './upload/TextReader';
import { EditorState, convertToRaw } from 'draft-js';
import TextEditPopup from './TextEditPopup';
import DynamicDialog from './DynamicDialog';
import CommonDialog from './common/CommonDialog';

const TextView = (props) => {
    async function getImageList(style,genre,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/new/"+style+"/"+genre+"//"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserImageList(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImageInfo(groupId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/info/"+groupId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getImageReply(groupId,replyCommentId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/reply/"+groupId+"/"+replyCommentId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImageReply(groupId,replyCommentId){
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/reply/"+groupId+"/"+replyCommentId).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function deleteImage(groupId){
        let deletePassword = document.getElementById("delete-password").value
        return await new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/text/post/"+groupId,{deletePassword:deletePassword}).then((r)=>r.json().then((d)=>{
            return d
        }))
    }
    async function getStamp(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/stamp/user/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getFavoriteUserList(id,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/favorite/text/userList/"+id+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateAgeLimitByAdmin(groupId,ageLimit){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/ageLimit/"+groupId,{ageLimit:ageLimit})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateStyleOfPaintingByAdmin(groupId,style){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/style/"+groupId,{style:style})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function sendMosaicNoticeByAdmin(groupId){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/mosaic/"+groupId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function updateStatusByAdmin(userId,status){
        return await new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/login/status/"+userId,{status:status})
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    function search(keyword,style,nenrei,follow,auth,aiOrModel,user,tag,order,page){
        return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/text/search/",
            {keyword:keyword,style:style,ageLimit:nenrei,follow:follow,auth:auth,aiOrModel:aiOrModel,user:user,tag:tag,postDateFrom:"",postDateTo:"",order:order,page:page}
        ).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function get6MonthAvg(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/pageview/6MonthAvg").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // 投稿処理
    function upload(postType,text,groupId,stampId,commentId){
        let fapi = new ApiFetch()
        let fd = new FormData()
        fd.append("text",text)
        fd.append("stamp_id",stampId === undefined ? "" : stampId)
        commentId = commentId || ""
        fapi.fileUpload(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/"+postType+"/reply/"+groupId+"/"+commentId,fd).then((r)=>{
            r.json().then(json=>{
                if(json.result){
                    let text = document.getElementById("text")
                    text.value = ""
                    getImageReply(groupId,"",1).then(r=>{
                        if(r.result){
                            setImageReplyInfo(r.detail)
                        }
                    })
                } else {
                    dialog("エラー",json.errors.join("\r\n"))
                }
            })
        })
    }
    // クリップボードにコピー
    function copyTextToClipboard(text) {
        return navigator.clipboard.writeText(text)
    }
    let param = useParams()
    let groupId = param.id

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
        }
    },[loginInfo])

    // ユーザ情報ポップアップ
    const [displayId,setDisplayId] = useState()
    const [selfIntroduction,setSelfIntroduction] = useState()
    const [followPopup,setFollowPopup] = useState()
    const [follower,setFollower] = useState()

    // ナビゲート
    const navigate = useNavigate()

    const tagReplace = (node) => {
        if (node.name === 'span' && node.attribs.tag !== undefined) {
          return (
            <span {...node.attribs} onClick={() => navigate("/tag/"+node.attribs.tag+"/1")} style={{color:"#00AAFF",cursor:"pointer"}}>
              #{ domToReact(node.children) }
            </span>
          )
        }
        if (node.name === 'span' && node.attribs.href !== undefined) {
            return (
              <span {...node.attribs} onClick={() => navigate("/text/"+node.attribs.href)} style={{color:"#00AAFF",cursor:"pointer"}}>
                { domToReact(node.children) }
              </span>
            )
        }
        if (node.name === 'a') {
            return (
              <a href={"/jump/" + encodeURIComponent(node.attribs.href)}>{node.attribs.href}</a>
            )
        }
    }

    // 削除対象
    const [item, selectItem] = useState('')
    const [deleted, setDeleted] = useState('')

    // 画像遅延ロード
    const options = {
        root: null,
        rootMargin: "100px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target
                //imgEl.src = imgEl.dataset.src
                observer.unobserve(entry.target)
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.className === "replyLazy" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imageReplyPage * 10 - 1) ){
                    setImageReplyPage(imageReplyPage+1)
                }
                let lazyCount = document.querySelectorAll(".lazy").length
                let lazyHiddenCount = document.querySelectorAll(".lazy-hidden").length
                let imageCount = lazyCount + lazyHiddenCount
                if((imgEl.className === "p-1 lazy" || imgEl.className === "lazy-hidden")
                    && (imageCount - 1) === (imagePage * 30 - 1) && lazyCount < 31 && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 30 - 1)){
                    setImagePage(imagePage + 1)
                }
                if(imgEl.className === "lazy" && imgEl.dataset.type === "favorite" && imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (favoriteUserListPage * 30 - 1) ){
                    setFavoriteUserListPage(favoriteUserListPage+1)
                }
                if(imgEl.className === "p-0 lazy container" && imgEl.dataset.type === "search" && searchImage === 0){
                    setSearchImage(Math.random())
                }
              }
        })
    }, options)

    const [view,setView] = useState(0)
    const [imageInfo,setImageInfo] = useState({info:{id:"",title:"",description:""},detail:[{prompt:""}]})
    const [text,setText] = useState()
    const [userImageList,setUserImageList] = useState([])
    const [imageInfoStatus,setImageInfoStatus] = useState(false)
    const [imageDisplayFlag,setImageDisplayFlag] = useState(0)
    const [detailNo,setDetailNo] = useState(0)
    const [imagePage,setImagePage] = useState(1)
    const [imageList,setImageList] = useState([])
    const [stampList,setStampList] = useState([])
    const [stampMessage,setStampMessage] = useState("")
    const [width,setWidth] = useState(window.innerWidth*0.8)
    const [height,setHeight] = useState(window.innerHeight*0.8)
    const [follow,setFollow] = useState(false)
    const [okButtonShow,setOkButtonShow] = useState(false)
    const [pv,setPV] = useState(1)
    const [url,setURL] = useState("")
    const [questionId,setQuestionId] = useState("")
    const [tag,setTag] = useState("")
    const [searchImage,setSearchImage] = useState(0)
    const [tabKey,setTabKey] = useState("")

    // 管理者用
    const [adminSelectItem,setAdminSelectItem] = useState("allAges")

    // お気に入りユーザ一覧
    const [favoriteUserList,setFavoriteUserList] = useState([])
    const [favoriteUserListPage,setFavoriteUserListPage] = useState(1)
    const [showFavoriteUserList,setShowFavoriteUserList] = useState(false)

    // 返信情報
    const [imageReplyPage,setImageReplyPage] = useState(0)
    const [imageReplyInfo,setImageReplyInfo] = useState([])

    // 初期処理
    useEffect(() =>{
        // スクロールを最上位に戻す
        window.scrollTo({top:0,left:0,behavior:"instant"})
        setOkButtonShow(false)
        getImageInfo(groupId).then(json => {
            if(json.result){
                let info = json.info

                setImageDisplayFlag(info.confirm_flag)                
                if(!info.is_logged_in){
                    // ログイン確認できないため、ログイン情報を削除
                    setLoginInfo([])
                }
                // 質問ID
                setQuestionId(json.info.question_id)
                // 情報を保持
                setImageInfo(json)
                // 本文
                setText(JSON.parse(json.info.text))
                // フォロー状況を設定
                setFollow(json.info.follow)
                // PVを設定
                setPV(json.info.pv)
                // データ受信状況を設定
                setImageInfoStatus(true)
                // タイトル設定
                document.querySelector("title").textContent = json.info.title + "のイラスト - アワートAI"

                // タグ
                let tags = json.info.tags.filter(tag => {
                    // 自動で追加するタグは除外する
                    return tag !== "AIイラスト"
                }).map(tag => "#" + tag).join(" ")
                // URL
                setURL("https://twitter.com/intent/tweet?ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Emention%7Ctwgr%5Eourt_official&text="
                    + encodeURIComponent("AIイラスト生成&投稿サイト「アワートAI」の投稿を共有しました！\nタイトル：「" + json.info.title + "」\n" + ApiFetch.API_PROTOCOL+"//ourt-ai.work/text/"+groupId + "\n#アワートAI #AIイラスト #AIart")
                )

            } else {
                dialog("エラー",json.errors.join("\r\n"))
            }
        })
        setImageReplyPage(1)
        getImageReply(groupId,"",1).then(r=>{
            if(r.result){
                setImageReplyInfo(r.detail)
            } else {
                setImageReplyInfo([])
            }
        })
        setSearchImage(0)
        setSensitiveShow(false)
    },[groupId])

    useEffect(() => {
        if(imageReplyPage > 1){
            getImageReply(groupId,"",imageReplyPage).then(r=>{
                if(r.result){
                    setImageReplyInfo(imageReplyInfo.concat(r.detail))
                }
            })
        }
    },[imageReplyPage])

    useEffect(() => {
        if(imageReplyPage > 0){
            getImageReply(groupId,"",imageReplyPage).then(r=>{
                if(r.result){
                    setImageReplyInfo(r.detail)
                } else {
                    setImageReplyInfo([])
                }
            })
        }
    },[deleted])

    useEffect(() => {
        /*getImageList(imagePage).then(r=>{
            if(r.result){
                setImageList(imageList.concat(r.data))
            }
        })*/
    },[imagePage])

    useEffect(() => {
        if(favoriteUserListPage > 1){
            getFavoriteUserList(groupId,favoriteUserListPage).then(r=>{
                if(r.result){
                    setFavoriteUserList(favoriteUserList.concat(r.data))
                }
            })
        }
    },[favoriteUserListPage])

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".replyLazy").forEach(e => observer.observe(e))
    },[imageInfo,imageReplyInfo,view,groupId,deleted])

    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
        //document.querySelectorAll(".lazy-hidden").forEach(e => observer.observe(e))
    },[groupId])

    useEffect(() => {
        if(searchImage === 0 || imageInfo.info.id === "") return
        let info = imageInfo.info
        let genre = ""
        if(info.age_limit === 1){
            genre = "general"
        } else if(info.age_limit === 2) {
            genre = "pg12"
        } else if(info.age_limit === 3) {
            genre = "r15"
        } else if(info.age_limit === 4) {
            genre = "r18"
        } else if(info.age_limit === 5) {
            genre = "r18g"
        }
        if(info.tags && info.tags.length > 0){
            let tag = info.tags[Math.floor(Math.random() * info.tags.length)]
            setTag(tag)
            search("",[{value:1,checked:info.style_of_painting === 1},{value:2,checked:info.style_of_painting === 2},{value:3,checked:info.style_of_painting === 3}],
                [
                    {"name": "全年齢","value": 1,"checked": info.age_limit === 1},
                    {"name": "PG-12","value": 2,"checked": info.age_limit === 2},
                    {"name": "R-15","value": 3,"checked": info.age_limit === 3},
                    {"name": "R-18","value": 4,"checked": info.age_limit === 4},
                    {"name": "R-18G","value": 5,"checked": info.age_limit === 5}
                ],"3",[{value: 1,checked:0}],[],[],[tag],
                [{"order": "random"}],1).then(r=>{
                if(r.result){
                    setImageList([].concat(r.data))
                }
            })
        } else {
            // 最新の画像を取得する場合はこれ
            let styles = ["illustration","photorealistic","semirealism"]
            let style = styles[info.style_of_painting-1]
            getImageList(style,genre,imagePage).then(r=>{
                if(r.result){
                    setImageList([].concat(r.data))
                }
            })
        }
        // 過去6ヵ月間の平均閲覧数の多いユーザ
        get6MonthAvg().then(r => {
            if(r.result){
                setLast6MonthAvgList(r.data)
            }
        })
    },[imageInfo])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    window.onresize = () => {
        /*let width = document.getElementById("#"+imageInfo.detail[0].id).naturalWidth
        let height = document.getElementById("#"+imageInfo.detail[0].id).naturalHeight
        if(width > height){
            setWidth(window.innerWidth*0.8)
            setHeight(window.innerHeight*parseFloat(height)/parseFloat(width))
        } else {
            setWidth(window.innerWidth*parseFloat(width)/parseFloat(height))
            setHeight(window.innerHeight*0.8)
        }*/
    }

    // フォロー解除確定・コメント削除OKボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            if(item.type === "follow"){
                followDelete(imageInfo.info.user_id,dialog).then(r=>{
                    if(r){
                        setFollow(false)
                    }
                    setOkButtonShow(false)
                })
            } else if(item.type === "text_reply") {
                deleteImageReply(groupId,item.id).then(r=>{
                    if(r.result){
                        setDeleted(item.id)
                    } else {
                        dialog("エラー",r.errors)
                    }
                    setOkButtonShow(false)
                })
            }
        }}>OK</Button>
    }

    function selectImg(id,ext){
        // gif 1枚だけなら直接再生する
        if(imageInfo.detail.length === 1 && ext === "gif"){
            return ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/text/post/s/"+id+".webp"
        } else {
            return ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/text/post/t/"+id+"_m"+ApiFetch.API_THUMB_EXT
        }
    }

    useEffect(() => {
        if(view === 0) {
            setDetailNo(0)
        }
    },[view])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(false)
    const [showEditPopup,setShowEditPopup] = useState(false)
    const [title,setTitle] = useState("")
    const [description,setDescription] = useState("")
    const [last6MonthAvg,setLast6MonthAvgList] = useState([])
    const [showPointSend,setShowPointSend] = useState(false)
    const [styleOptions,setStyleOptions] = useState([])
    const [styleSelected,setStyleSelected] = useState([])
    const [userTagSelected,setUserTagSelected] = useState([])
    const [sensitiveShow,setSensitiveShow] = useState(false)
    const [showDisplaySetting,setShowDisplaySetting] = useState(false)

    // 言語設定
    const {language,setLanguage} = useContext(LanguageCtx)
    useEffect(() => {
        if(language === "ja"){
            setTitle(imageInfo.info.title)
            setDescription(imageInfo.info.description)
        } else if(language === "en"){
            if(imageInfo.info.title_en.length > 0){
                setTitle(imageInfo.info.title_en)
            } else {
                setTitle(imageInfo.info.title)
            }
            if(imageInfo.info.description_en.length > 0){
                setDescription(imageInfo.info.description_en)
            } else {
                setDescription(imageInfo.info.description)
            }
        }
    },[language,imageInfo])

    const [editorState,setEditorState] = useState(() =>
        EditorState.createEmpty()
    )
    function editorStateChangeHandler(editorState){       
        setEditorState(editorState) 
        const contentState = editorState.getCurrentContent()
        const raw = convertToRaw(contentState)
        console.log(raw)
    }

    if(view !== 0){
        return (
        <Container className='p-0' style={{width:"100%",height:"100%",backgroundColor:"#FFFFFF",textAlign:"center"}}>
            {imageInfo.detail.map((d,i) => {
                return (
                    <Image loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/text/post/s/"+d.id+".webp"} style={{width:"100%",maxWidth:"100%",height:window.innerHeight,cursor:"pointer"}} className="p-2" onClick={() => {
                        // スクロールを最上位に戻す
                        window.scrollTo({top:0,left:0,behavior:"instant"})
                        setView(0)
                    }} key={d.id} id={d.id} onLoad={(e) => {
                        e.currentTarget.style.width = "auto"
                        e.currentTarget.style.height = "auto"
                    }} />
                )
            })}
        </Container>)
    } else {
        let img;
        let icon;
        let followButton

        /**
         * 以下の場合フォローボタンを表示しない
         * 投稿者本人の場合
         * 投稿者が匿名の場合
         */
        if(!(loginInfo.userId === imageInfo.info.user_id) && imageInfo.info.user_id !== "anonymous"){
            if(follow){
                followButton = <Button className='m-1' variant="outline-secondary" onClick={(e) => {
                    selectItem({type:"follow"})
                    setOkButtonShow(true)
                    dialog("確認",t("common.unfollow"))
                }}><Icon.PersonDash /></Button>
            } else {
                followButton = <Button className='m-1' variant="danger" onClick={(e) => {
                    if(loginInfo.result === false){
                        dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                        return
                    }
                    if(loginInfo.userId === imageInfo.info.user_id){
                        dialog("エラー","自分自身はフォローできません。")
                        return
                    }
                    followPost(imageInfo.info.user_id,dialog).then(r => {
                        if(r){
                            setFollow(true)
                        }
                    })
                }}>{t("common.followUs")}</Button>
            }
        }
        if(imageInfoStatus){
            if(imageDisplayFlag === 0 && imageInfo.detail.length > 0){
                img = <Image id={"#"+imageInfo.detail[0].id} loading="eager" src={selectImg(imageInfo.detail[0].id,imageInfo.detail[0].ext)} style={{filter:!sensitiveShow && imageInfo.info.sensitive_flag === 1 ? "blur(100px)" : "none",objectFit:"contain",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="p-2 mainImage" onClick={() => setView(groupId)} />
            } else if(imageDisplayFlag === 1) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>PG-12指定作品<br />PG-12指定作品を表示する場合、<br />ログインして設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 2) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-15指定作品<br />R-15指定作品を表示する場合、<br />ログインして設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 3) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18指定作品<br />R-18指定作品を表示する場合、<br />ログインして設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 4) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18G指定作品<br />R-18G指定作品を表示する場合、<br />ログインして設定画面より表示設定を行ってください。</div></div>
            } else if(imageDisplayFlag === 5) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>PG-12指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else if(imageDisplayFlag === 6) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-15指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else if(imageDisplayFlag === 7) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else if(imageDisplayFlag === 8) {
                img = <div style={{position:"absolute",width:"100%",height:"100%",border:"1px solid #555555"}}><div style={{textAlign:"center",fontSize:"24px"}}>R-18G指定作品<br />現在非表示設定になっているため、<br />表示するには設定画面より変更してください。</div></div>
            } else {
                img = ""
            }
        } else {
            //img = <Image src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/text/post/t/'+(groupId)+"_in"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",borderRadius:"20px",cursor:"pointer"}} className="p-0" />
        }
        let versions = {
            "1D44365E":"NAI Diffusion Anime (Curated)",
            "81274D13":"NAI Diffusion Anime (Full)",
            "1D09D794":"NAI Diffusion Furry (Beta V1.3)",
            "04c147f2":"v1.1 full ema",
            "4567aa0f":"v1.1",
            "11d755f8":"v1.2 full ema",
            "5e18682b":"v1.2",
            "ec706de4":"v1.3 full ema",
            "3706d7ad":"v1.3",
            "06c50424":"v1.4 full ema",
            "7460a6fa":"v1.4",
            "84692140":"v1.3 float16",  // Waifu Diffusion
            "4470c325":"v1.3 float32",
            "e1de58a9":"v1.3 full",
            "3e1a125f":"v1.3 full opt", // Waifu Diffusion
            "e2ec4647":"16",            // HentaiDiffusion
            "3a0cfc1c":"17",            // HentaiDiffusion
            "abaf1da6":"half",          // ACertainModel-half
            "27bd26ec":"half",          // ACertainThing-half
            "b5c0b653":"V2.2 (Anime)",  // Protogen V2.2 (Anime)
            "fde2460c":"V1.0",          // ourtAI Diffusion V1.0
            "4048130a":"V2.0",          // Counterfeit V2.0
            "8838e0d1fb":"V2.0",        // Counterfeit V2.0
            "f3b033b02f":"V2.0",        // Counterfeit V2.0
            "71e703a0fc":"V2.5",        // Counterfeit V2.5
            "fc9d6d1ff2":"v1.0 fp16",   // SukiyakiMix v1.0
            "6e350084a6":"anime_3.1_A", // 7th_anime_3.1_A
            "a916690d6d":"Anime V1",    // ourt AI Diffusion Anime V1
            "1b5f8211ec":"v1.0 F16",    // Aurora v1.0 F16
            "6772b99463":"v9b"          // blue_pencil_v9b
        }
        let modelVersion = ""
        if(imageInfoStatus && imageInfo.detail.length > 0 && imageInfo.detail[detailNo] && versions[imageInfo.detail[detailNo].model_hash]){
            modelVersion = versions[imageInfo.detail[detailNo].model_hash]
        }
        document.onkeydown = (e) => {
            if(e.key === "ArrowLeft"){
                if(detailNo > 0){
                    let detail = imageInfo.detail[detailNo-1]
                    document.querySelector(".mainImage").src = selectImg(detail.id,detail.ext)
                    setDetailNo(detailNo-1)
                } else if(detailNo === 0) {
                    let detail = imageInfo.detail[imageInfo.detail.length-1]
                    document.querySelector(".mainImage").src = selectImg(detail.id,detail.ext)
                    setDetailNo(imageInfo.detail.length-1)
                }
            } else if(e.key === "ArrowRight"){
                if(imageInfo.detail.length > detailNo + 1){
                    let detail = imageInfo.detail[detailNo+1]
                    document.querySelector(".mainImage").src = selectImg(detail.id,detail.ext)
                    setDetailNo(detailNo+1)
                } else if(imageInfo.detail.length === detailNo + 1){
                    let detail = imageInfo.detail[0]
                    document.querySelector(".mainImage").src = selectImg(detail.id,detail.ext)
                    setDetailNo(0)
                }
            }
        }
        const breakpointColumnsObj = {
            default: 9,
            1800: 8,
            1600: 7,
            1400: 6,
            1200: 5,
            992: 4,
            768: 3,
            576: 2,
        }
    return (
    <div className="wrapper">
        <script type="text/javascript">
            amzn_assoc_ad_type = "link_enhancement_widget";
            amzn_assoc_tracking_id = "ourt-ai-22";
            amzn_assoc_linkid = "d065a900ce46e35d1230dbafd6b90f07";
            amzn_assoc_placement = "";
            amzn_assoc_marketplace = "amazon";
            amzn_assoc_region = "JP";
        </script>
        <script src="//ws-fe.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&Operation=GetScript&ID=OneJS&WS=1&MarketPlace=JP"></script>
        <CommonDialog
        maxWidth="1200px"  // 管理者画面用に大きな幅を設定
        minWidth="600px"   // 最小幅も大きめに設定
        fullScreen={window.innerWidth < 1024} // タブレット以下でフルスクリーン
        open={show} onClose={() => setShow(false)} content={<><Alert severity='info' style={{display:dialogTitle.length > 0 ? "block" : "none"}}>{dialogTitle}</Alert><br />{dialogMessage}<br />{okButton}</>} />
        {showEditPopup ? <TextEditPopup switch={setShowEditPopup} groupId={groupId} /> : ""}
        {showPointSend ? <PointSend userId={imageInfo.info.user_id} userName={imageInfo.info.user_name} dialog={dialog} switch={setShowPointSend} /> : ""}
        {showDisplaySetting ? (
            <DynamicDialog width={300} height={120} switch={setShowDisplaySetting} content={
                <div style={{backgroundColor:"inherit",width:"auto"}} className='p-0'>
                <InputGroup style={{}}>
                    <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onChange={(e) => {
                        updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                            if(r.result){
                                isLoggin().then(json => {
                                    setLoginInfo(json)
                                })
                            }
                        })
                        //setOmitContinuous(e.currentTarget.checked)
                    }} />
                    <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                </InputGroup>
                <InputGroup style={{}}>
                    <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onChange={(e) => {
                        updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                            if(r.result){
                                isLoggin().then(json => {
                                    setLoginInfo(json)
                                })
                            }
                        })
                        //setTileMode(e.currentTarget.checked)
                        }} />
                    <Form.Control type="text" value={t("common.tileMode")} readOnly />
                </InputGroup>
                </div>
            }/>
        ) : ""}
        <Header />
        <Category />
        <div className='w-100'>
            {imageInfoStatus && imageInfo.detail.length > 1 ? (
                <Container className="d-flex justify-content-start align-items-center p-0" style={{flexWrap:"wrap",width:"100%",backgroundColor:"#FFFFFF",border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                    {imageInfo.detail.map((d,i) => {
                        return (
                            <div style={{flexShrink:0,width:"100px",height:"100px",overflow:"hidden"}} className="m-1" key={d.id}>
                                <Image loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/text/post/t/"+d.id+ApiFetch.API_THUMB_EXT} style={{filter:!sensitiveShow && imageInfo.info.sensitive_flag === 1 ? "blur(100px)" : "none",objectFit:"cover",width:"100%",height:"100%",cursor:"pointer",backgroundColor:detailNo === i ? "#FFFFFF" : "inherit",opacity:detailNo === i ? "0.3" : "1"}} onClick={() => {
                                    document.querySelector(".mainImage").src = selectImg(d.id,d.ext)
                                    setDetailNo(i)
                                }} />
                            </div>
                        )
                    })}
                </Container>
            ) : ""}
            {loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator") ? (
            <Container style={{width:"400px",border:"1px solid red"}} className="mb-3 p-3">
                <Form.Select className="mb-3" value={adminSelectItem} style={{}}
                    onChange={(e) => setAdminSelectItem(e.currentTarget.value)}
                >
                    <option value="年齢制限" disabled>【年齢制限】</option>
                    <option value="allAges">全年齢(性表現なし)</option>
                    <option value="pg12">PG-12</option>
                    <option value="pg12Notice">PG-12 注意喚起あり</option>
                    <option value="r15">R-15</option>
                    <option value="r15Notice">R-15 注意喚起あり</option>
                    <option value="r18">R-18</option>
                    <option value="r18Notice">R-18 注意喚起あり</option>
                    <option value="r18g">R-18G</option>
                    <option value="r18gNotice">R-18G 注意喚起あり</option>
                    <option value="mosaicNotice">モザイクをかけるように注意喚起する</option>
                    <option value="" disabled>-------------------------------------------</option>
                    <option value="画風" disabled>【画風】</option>
                    <option value="illust">イラスト</option>
                    <option value="semi">セミリアル</option>
                    <option value="photo">フォト</option>
                    <option value="" disabled>-------------------------------------------</option>
                    <option value="アカウント" disabled>【アカウント】</option>
                    <option value="account_suspend" style={{color:"red"}}>一時停止(利用規約とガイドラインの再確認が必要)</option>
                    <option value="account_permanently_frozen" style={{color:"red"}}>永久凍結</option>
                </Form.Select>
                <Button style={{}}
                    onClick={(e) => {
                        if(adminSelectItem === "illust" || adminSelectItem === "semi"|| adminSelectItem === "photo"){
                            updateStyleOfPaintingByAdmin(groupId,adminSelectItem).then(r => {
                                if(r.result){
                                    dialog("確認","画風を「"+r.data.styleReturn+"」に更新しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        } else if(adminSelectItem === "mosaicNotice") {
                            sendMosaicNoticeByAdmin(groupId).then(r => {
                                if(r.result){
                                    dialog("確認","モザイク是正要求通知を登録しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        } else if(adminSelectItem === "account_suspend" || adminSelectItem === "account_permanently_frozen"){
                                let status = -1
                                if(adminSelectItem === "account_suspend"){
                                    status = 3
                                } else {
                                    status = 4
                                }
                                updateStatusByAdmin(imageInfo.info.user_id,status).then(r => {
                                    if(r.result){
                                        dialog("確認","アカウントを「"+r.data.accountReturn+"」しました。")
                                    } else {
                                        dialog("エラー",r.errors)
                                    }
                                })
                        } else {
                            updateAgeLimitByAdmin(groupId,adminSelectItem).then(r => {
                                if(r.result){
                                    dialog("確認","年齢制限を「"+r.data.ageLimitReturn+"」に更新しました。")
                                } else {
                                    dialog("エラー",r.errors)
                                }
                            })
                        }
                    }}
                >実行(管理者権限)</Button>
                <Button style={{marginLeft:"10px"}} onClick={() => dialog("",<UserManageInfo userIdOrDisplayId={imageInfo.info.user_id} dialog={dialog} change={groupId} />)}>管理情報</Button>
            </Container>
            ) : ""}
            {
                // タイトル情報など
            }
            <Container className='p-0'>
                <Container className='p-0' style={{fontWeight:"bold",fontSize:"21px"}}>{parse(title.replace(/[#＃]{1}([Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-・]?[^　#＃\r\n]+)/g,'<span tag="$1">$1</span>'),{replace:tagReplace})}</Container>
                <Container className='p-0' style={{color:"#555555"}}>{imageInfo.info.booking_datetime === "0000-00-00 00:00:00" ? imageInfo.info.create_datetime : imageInfo.info.booking_datetime} {t("common.posted")}{imageInfo.info.booking_flag ? "(予約)" : ""} <Icon.Eye></Icon.Eye> {pv}
                    <div style={{position:"fixed",top:0,left:0,zIndex:3,width:"100%",height:"100%",backgroundColor:"#333333",opacity:0.7,display:showFavoriteUserList ? "block" : "none"}}
                        onClick={(e) => {
                            setShowFavoriteUserList(false)
                        }}
                    />
                    <Container style={{position:"absolute",zIndex:3,top:window.scrollY,height:"100%",overflow:"auto",backgroundColor:"#FFFFFF",display:showFavoriteUserList ? "block" : "none"}}
                    className="w-100"
                    >
                        <h3>{t("common.likedUsers")}</h3>
                        <Button variant='outline-secondary' onClick={() => setShowFavoriteUserList(false)}>{t("common.close")}</Button>
                        <Row>
                        {favoriteUserList.map((d,i) => {
                            return  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="p-1" key={i}>
                                        <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                            <div className='d-flex justify-content-start'>
                                                <div>
                                                    <UserAvatarWithLikes 
                                                        userId={d.follow_user_id} 
                                                        size={100} 
                                                        linkTo={"/user/"+d.follow_user_id}
                                                        className="lazy"
                                                        data-type="favorite" 
                                                        data-observe="0" 
                                                        data-no={i}
                                                    />
                                                </div>
                                                <div className='p-3'>
                                                    <Link to={"/user/"+d.follow_user_id} style={{textDecoration:"none",color:"#000000"}}>{d.user_name}</Link>
                                                    <br />
                                                    {loginInfo.userId !== d.follow_user_id ? 
                                                    (<FollowButton userId={d.follow_user_id} follow={d.follow} userName={d.user_name} />)
                                                    : ""}
                                                </div>
                                            </div>
                                            <p>{d.self_introduction}</p>
                                        </Container>
                                    </Col>
                        })}
                        </Row>
                    </Container>
                    &nbsp;
                    <span style={{cursor:"pointer"}} onClick={(e) => {
                        getFavoriteUserList(groupId,favoriteUserListPage).then(r => {
                            if(r.result){
                                setFavoriteUserList(r.data)
                                setShowFavoriteUserList(true)
                            }
                        })
                    }}>いいね {imageInfo.info.favorite_count}</span>
                    {false ? (<FavoriteIcon style={{cursor:"pointer",marginLeft:"20px",fontSize:"24px"}} type="image" id={groupId} favorite={imageInfo.info.favorite} dialog={dialog} count={-1} />) : ""}
                    <FavoriteIconV2 style={{cursor:"pointer",margin:"0 20px",fontSize:"20px"}} type="text" id={groupId} favorite={imageInfo.info.favorite} dialog={dialog} count={-1} />
                    {imageInfo.info.style_of_painting === 1 ? (<Badge bg="secondary" className='m-1'>{t("upload.image.illustration")}</Badge>) : ""}
                    {imageInfo.info.style_of_painting === 2 ? (<Badge bg="secondary" className='m-1'>{t("upload.image.photorealistic")}</Badge>) : ""}
                    {imageInfo.info.style_of_painting === 3 ? (<Badge bg="secondary" className='m-1'>{t("upload.image.semirealism")}</Badge>) : ""}
                    {imageInfo.info.age_limit === 2 ? (<Badge bg="secondary" className='m-1'> PG-12</Badge>) : ""}
                    {imageInfo.info.age_limit === 3 ? (<Badge bg="danger" className='m-1'> R-15</Badge>) : ""}
                    {imageInfo.info.age_limit === 4 ? (<Badge bg="danger" className='m-1'> R-18</Badge>) : ""}
                    {imageInfo.info.age_limit === 5 ? (<Badge bg="danger" className='m-1'> R-18G</Badge>) : ""}
                    <Badge bg="secondary" style={{cursor:"pointer",padding:"5px"}}>
                        <a href={imageInfo.detail[detailNo] && ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/text/post/s/'+imageInfo.detail[detailNo].id+".webp"} download><Icon.Download style={{fontSize:"18px",color:"#EEE"}} /></a>
                    </Badge>
                    <Badge className='m-1' style={{display:imageInfo.detail[detailNo] && imageInfo.detail[detailNo].use_ai_generation === 1 ? "inline" : "none",cursor:"pointer"}}>
                        <Link to={"/upload/image"} style={{textDecoration:"none",color:"#FFFFFF"}}>AI生成機能を使用</Link>
                    </Badge>
                    &nbsp;
                    <Badge bg="primary" style={{cursor:"pointer",padding:"5px",display:imageInfo.info.user_id === loginInfo.userId || (loginInfo.role && loginInfo.role.find(d => d.role_div === "admin" || d.role_div === "moderator")) ? "inline" : "none"}}
                        onClick={() => {
                            //navigate("/edit/"+groupId)
                            setShowEditPopup(true)
                        }}>
                        <Icon.PencilSquare style={{color:"#FFFFFF"}} /> <span style={{color:"#FFFFFF"}}>{t("common.edit")}</span>
                    </Badge>
                    &nbsp;
                    <Icon.ShareFill style={{marginLeft:"10px",cursor:"pointer"}}
                        onClick={() => dialog(t("common.shareSNS"),<a href={url} target="_blank" rel="noreferrer" style={{textDecoration:"none",padding:"2px 10px",borderRadius:"15px",backgroundColor:"#1D9BF0",color:"#FFFFFF",border:"1px solid #1D9BF0"}}><Icon.Twitter /> Twitter</a>)}
                    />
                </Container>
                <Container className='d-flex flex-row justify-content-start flex-nowrap' style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                    <Container>
                        <Row className='d-flex justify-content-start'>
                            <Col xs={12} sm={9} md={9} lg={9} xl={9} xxl={9} style={{margin:"0 auto",overflow:"hidden"}} className='d-flex justify-content-start'>
                                {imageInfoStatus ? (
                                    <UserAvatarWithLikes 
                                        userId={imageInfo.info.user_id} 
                                        size={50}
                                        className="p-2"
                                        linkTo={"/user/"+imageInfo.info.user_id}
                                        style={{cursor:"pointer"}}
                                    />
                                ) : (
                                    <Image style={{width:"100px",height:"100px",borderRadius:"50px",cursor:"pointer"}} className="p-2" />
                                )}
                                <strong style={{margin:"auto 20px",wordWrap:"wrap"}}>{imageInfo.info.user_id !== "anonymous" ? imageInfo.info.user_name : "匿名ユーザ"}
                                <UserMark sms_auth={imageInfo.info.sms_auth} role={imageInfo.info.role} plan={imageInfo.info.plan} beginner={imageInfo.info.beginner} identity_confirmed={imageInfo.info.identity_confirmed} dialog={dialog} />
                                </strong>
                                {followButton}
                            </Col>
                            <Col xs={3} sm={3} md={3} lg={3} xl={3} xxl={3} className='d-flex justify-content-start'>
                                <Button variant='outline-danger' title='ポイントを贈る'
                                className='m-1'
                                style={{display:loginInfo.userId === imageInfo.info.user_id || imageInfo.info.user_id === "anonymous" || imageInfo.info.user_id === undefined ? "none" : "block"}}
                                onClick={() => setShowPointSend(true)}
                                ><Icon.PersonHeart style={{fontSize:"24px"}} /></Button>

                                <NavDropdown title={(
                                <Icon.ThreeDots style={{fontSize:"24px"}} />
                                )} id="report-dropdown" disabled={loginInfo.result === true && loginInfo.status !== 0} className='m-3'>
                                    <NavDropdown.Item className='p-0 text-center'><MuteButton mute={imageInfo.info.mute} userId={imageInfo.info.user_id} userName={imageInfo.info.user_name} /></NavDropdown.Item>
                                    <NavDropdown.Item className='p-0 text-center'
                                    onClick={() => {
                                        if(loginInfo.result === false){
                                            dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                                            return
                                        }
                                        dialog(t("common.reportAProblem"),<Report type="text" groupId={groupId} title={imageInfo.info.title} dialog={dialog} />)
                                    }}><Icon.ExclamationCircle /> {t("common.reportAProblem")}</NavDropdown.Item>
                                </NavDropdown>
                            </Col>
                        </Row>
                        {imageInfo.info.user_id === "anonymous" ? (
                                <div>
                                    <FloatingLabel controlId="delete-password" label="削除パスワード">
                                        <Form.Control type="password" cows="10" autoComplete="new-password" />
                                    </FloatingLabel>
                                    <Button onClick={(e) => {
                                        let delPass = document.getElementById("delete-password").value
                                        if(delPass.trim().length === 0){
                                            dialog("エラー","削除パスワードを入力してください。")
                                            return
                                        }
                                        deleteImage(groupId).then((r)=>{
                                            if(r.result){
                                                dialog("確認","削除しました")
                                            } else {
                                                dialog("エラー",r.errors)
                                            }
                                        })
                                    }}>削除</Button>
                                </div>
                            ):""}
                    </Container>
                </Container>
                <Container className='p-0' style={{position:"relative",width:"100%",height:"200px",padding:0}}>
                    <p style={{position:"absolute",top:"0",fontSize:"24px",display:!sensitiveShow && imageInfo.info.sensitive_flag === 1 ? "block":"none"}}>この作品はセンシティブなものとして設定されています。</p>
                    <Button variant='secondary'
                    onClick={() => setSensitiveShow(true)}
                    style={{position:"absolute",top:"80px",fontSize:"24px",zIndex:2,display:!sensitiveShow && imageInfo.info.sensitive_flag === 1 ? "block":"none"}}>表示する</Button>
                    {img}
                    {imageInfoStatus && imageInfo.detail.length > 1 ? <Container className='p-0' style={{position:"absolute",bottom:"0",height:"100px",background:"linear-gradient(transparent, #FFFFFF)",cursor:"pointer"}} onClick={() => setView(groupId)}><Container style={{padding:"5px",width:"300px",fontSize:"24px",fontWeight:"bold",borderRadius:"25px",border:"1px solid #000000",textAlign:"center",backgroundColor:"#FFFFFF",cursor:"pointer"}}>すべて表示</Container></Container> : ""}
                </Container>
                <Container className='mb-3' style={{color:"#555555"}}>{parse(description.replace(/[#＃]{1}([Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー._-・]?[^　 #＃\r\n]+)/g,'<span tag="$1">$1</span>').replace(/\r\n|\r|\n/g,"<br />").replace(/https:\/\/ourt-ai\.work\/image\/([0-9a-z-]{36})/g,"<span href='$1/'>画像リンク</span><br />")
                .replace(/(https?:\/\/[\w!?/+\-_~;.,*&@#$%()'=[\]]+)/g,'<a href="$1">$1</a>'),{replace:tagReplace})}</Container>
                <Typeahead id="tag-select" placeholder={"ユーザータグ"}
                    className="mb-3 d-none"
                    multiple
                    clearButton={true}
                    onInputChange={(input) => {
                        // console.log(styleOptions)
                    }}
                    onKeyDown={(e) => {
                        if(e.key === "Enter" && String(e.currentTarget.value).trim().length > 0){
                            setStyleSelected(styleSelected.concat(e.currentTarget.value))
                        }
                    }}
                    onBlur={(e) => {
                        if(String(e.target.value).trim().length > 0){
                            setStyleSelected(styleSelected.concat(e.target.value))
                        }
                    }}
                    onChange={(selected) => {
                        // let value = selected.length === 0 ? "no-select" : selected[0]
                        setStyleSelected(selected)
                    }}
                    selected={styleSelected}
                    defaultSelected={[]}
                    options={styleOptions}
                />
                {imageInfoStatus && questionId !== "" ? (
                    <QuestionAnswer
                        questionId={questionId}
                    />
                ) : ""}
                {imageDisplayFlag === 0 ? <TextReader onChange={editorStateChangeHandler} raw={text} /> : ""}
                {imageInfoStatus && imageInfo.info.series && imageInfo.info.series.length > 0 ? (
                        <h5>この作品が登録されているシリーズ</h5>
                ) : ""}
                <Row>
                {imageInfoStatus && imageInfo.info.series && imageInfo.info.series.map((d,i) => {
                    let ageLimit = ["全年齢","PG12","R15","R18","R18G"]
                    let id = d.info.display_id.length > 0 ? d.info.display_id : d.info.user_id
                    return  <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="p-1" key={i}>
                                <Container className="p-3" style={{border:"1px solid #CCCCCC",borderRadius:"5px"}}>
                                    <div className='d-flex justify-content-start'>
                                        <div>
                                            <div style={{position:"relative"}}>
                                                <Link to={"/series/"+id+"/"+d.info.series_link}>
                                                    <Image data-type="series" data-observe="0" data-no={i} className="lazy" loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/series/"+d.info.series_id+".webp?"+d.info.update_datetime} style={{width:"250px",height:"auto",borderRadius:"5px"}} />
                                                </Link>
                                            </div>
                                        </div>
                                        <div style={{marginLeft:"10px"}}>{d.info.series_name}<br />
                                        {parse(d.info.series_description.substring(0,50).replace(/\r|\n|\r\n/g,"<br/>"),{})}<br /><br />
                                        年齢制限：{ageLimit[d.info.series_age_limit-1]}<br />
                                        </div>
                                    </div>
                                </Container>
                            </Col>
                })}
                </Row>
            </Container>
            {imageDisplayFlag === 0 ?
            <Container style={{display:"block"}} className="p-0 mb-3">
                <Tabs defaultActiveKey="comment" onSelect={(key) => {
                    setTabKey(key)
                    if(key === "other"){
                        // ユーザの投稿一覧を取得
                        getUserImageList(imageInfo.info.user_id,1).then(r => {
                            if(r.result){
                                setUserImageList(r.data)
                            }
                        })
                    }
                }}>
                    <Tab eventKey="comment" title={t("common.comments")}>
                        <Container className='p-0' style={{border:"1px solid #CCCCCC",borderTop:"none"}}>
                            <Row style={{display:"block",borderRadius:"5px",textAlign:"left",padding:"10px 5px",margin:"10px 0"}} className="w-100">
                                <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{margin:"0 auto",width:"100%"}}>
                                    <FloatingLabel
                                    onClick={() => {
                                        if(loginInfo.result === false){
                                            dialog(t("common.loginToContinue"),<RegistOrLogin dialog={dialog} />)
                                        }
                                    }}
                                    controlId="text" label="コメントを記載" className='mb-3 w-100' style={{lineHeight:"20px"}} onInput={(e) =>{
                                        let lineHeight = e.currentTarget.style.lineHeight.replace(/[^0-9.]+/,'')
                                        let n = e.nativeEvent.target.value.match(/\n/g)
                                        if(n === null){
                                            n = 1
                                        } else {
                                            n = n.length + 1
                                        }
                                        e.currentTarget.style.height = lineHeight * n + 30 + "px"
                                        document.querySelector(".textarea").style.height = lineHeight * n + 30 + "px"
                                    }}>
                                        <Form.Control
                                            className='textarea'
                                            as="textarea"
                                            style={{ width:"inherits",height: '50px' }}
                                            required
                                        />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={8} xxl={12} style={{margin:"0 auto",width:"100%"}}>
                                    <RIcon.FaStamp style={{color:"#555555",cursor:"pointer"}} onClick={() => {
                                        if(stampList.length > 0){
                                            setStampList([])
                                        } else {
                                            getStamp(loginInfo.userId,1).then(r => {
                                                if(r.result){
                                                    setStampList(r.data)
                                                    if(r.data.length === 0){
                                                        setStampMessage(<span>まだスタンプがありません。オリジナルのスタンプを登録してみませんか？：<Link to={"/stampManage"}>スタンプ管理</Link></span>)
                                                    } else {
                                                        setStampMessage("")
                                                    }
                                                }
                                            })
                                        }
                                    }} />&nbsp;
                                    <Button onClick={() => {
                                        if(loginInfo.result === false){
                                            dialog(t("common.info"),<RegistOrLogin dialog={dialog} />)
                                            return
                                        }
                                        let text = document.getElementById("text")
                                        if(text.value.trim().length === 0){
                                            dialog("エラー","コメントを入力して下さい。")
                                            return
                                        }
                                        if(text.value.trim().length > 2500){
                                            dialog("エラー","コメントは2500文字以内にして下さい。")
                                            return
                                        }
                                        upload("text",document.getElementById("text").value,groupId)
                                    }}>{t("common.comment")}</Button>
                                    {stampMessage}
                                    <Row style={{border:stampList.length > 0 ? "1px solid #555555" : "none",borderRadius:"5px"}}>
                                        <Col style={{display:stampList.length > 0 ? "block" : "none",margin:"0 auto"}} className="m-1">
                                            <Link to="/stampManage"><Icon.Plus style={{borderRadius:"5px",border:"3px solid #AAAAAA",fontSize:"64px",cursor:"pointer",width:"100px",height:"100px",margin:"0 auto"}} /></Link>
                                        </Col>
                                        {stampList.map((data,i) => {
                                            if(i === 30){
                                                return ""
                                            }
                                        return <Col style={{margin:"0 auto"}} className="m-1" key={i}>
                                                    <Container style={{position:"relative",width:"100px",height:"100px"}} className="p-0">
                                                        {
                                                        // <Badge bg="white" style={{cursor:"pointer",position:"absolute",backgroundColor:"#FFFFFF",padding:"5px",zIndex:1,top:"20px",right:"50px"}} onClick={() => navigate("/edit/"+data.group_id)}>
                                                        //     <Icon.PencilSquare style={{color:"#000000"}} /> <span style={{color:"#555555"}}>編集</span>
                                                        // </Badge>
                                                        // <FavoriteIcon type="image" id={data.group_id} style={{cursor:"pointer",position:"absolute",zIndex:"1",bottom:"20px",right:"20px"}} favorite={data.favorite} dialog={dialog} />
                                                        }
                                                        <Image loading="lazy" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="stamp" 
                                                            onClick={() => {
                                                                upload("text",document.getElementById("text").value,groupId,data.stamp_id)
                                                                setStampList([])
                                                            }}
                                                            onMouseOver={(e) => {
                                                                e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+ApiFetch.API_THUMB_EXT
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(data.stamp_id)+"_s"+ApiFetch.API_THUMB_EXT
                                                            }}
                                                        />
                                                    </Container>
                                                    <Container style={{fontWeight:"bold",fontSize:"15px"}}><Link to={"/text/"+(data.stamp_id)} style={{color:"#555555",textDecoration:"none"}}>{data.title}</Link></Container>
                                                </Col>
                                        })}
                                    </Row>
                                </Col>
                            </Row>
                            <Container>
                                {imageReplyInfo && imageReplyInfo.map((comment,i) => {
                                    return (
                                        <div key={i}>
                                            <Reply postType="text" groupId={groupId} comment={comment} i={i} imageInfo={imageInfo} upload={upload} selectItem={selectItem} setOkButtonShow={setOkButtonShow} dialog={dialog} />
                                            {/*comment.replyList.map((reply,j) => {
                                                return (<Reply postType="image" key={j} type={"reply-sub"} groupId={groupId} comment={reply} i={j} imageInfo={imageInfo} upload={upload} selectItem={selectItem} setOkButtonShow={setOkButtonShow} dialog={dialog} />)
                                            })*/}
                                        </div>
                                    )
                                })}
                            </Container>
                        </Container>
                    </Tab>
                    <Tab eventKey="info" title={t("common.info")}>
                        <Container className='p-3' style={{border:"1px solid #CCCCCC",borderTop:"none"}}>
                            {imageInfo.info.original === 1 ? (<Badge bg="secondary" className='m-1'><Icon.Brush /> {t("upload.image.original")}</Badge>) : ""}
                            {imageInfo.info.limited_publication === 1 ? (<Badge bg="secondary" className='m-1'><Icon.Eye /> {t("common.limited")}</Badge>) : ""}
                            <hr />
                            <Button className='mb-3' onClick={() => {
                                copyTextToClipboard(
                                    "Prompt:\r\n"+imageInfo.detail[detailNo].prompt+"\r\n"
                                    + "Negative Prompt:\r\n"+imageInfo.detail[detailNo].negative_prompt+"\r\n"
                                    + "Model:"+imageInfo.detail[detailNo].ai_model+"\r\n"
                                    + "Steps:"+imageInfo.detail[detailNo].steps + " "
                                    + "Scale:"+imageInfo.detail[detailNo].scale + " "
                                    + "Seed:"+imageInfo.detail[detailNo].seed + " "
                                    + "Sampler:"+imageInfo.detail[detailNo].sampler + " "
                                    + "Strength:"+imageInfo.detail[detailNo].strength
                                )
                                dialog("確認",t("common.promptInfoCopied"))
                            }}>{t("common.promptInfoCopy")}</Button>
                            <FloatingLabel controlId="prompt" label={t("upload.image.prompt")} className="mb-3" style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].prompt && imageInfo.detail[detailNo].prompt.length > 0 ? "block":"none"}}>
                                <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].prompt} readOnly　onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].prompt).then(() => dialog("確認","プロンプトをコピーしました。"))} style={{cursor:"pointer"}} />
                            </FloatingLabel>
                            <FloatingLabel controlId="negative-prompt" label={t("upload.image.negativePrompt")} className="mb-3" style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].negative_prompt && imageInfo.detail[detailNo].negative_prompt.length > 0 ? "block":"none"}}>
                                <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].negative_prompt} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].negative_prompt).then(() => dialog("確認","ネガティブプロンプトをコピーしました。"))} style={{cursor:"pointer"}}/>
                            </FloatingLabel>
                            <Row>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ai_model && imageInfo.detail[detailNo].ai_model !== "no-select" ? "block":"none"}}>
                                    <FloatingLabel controlId="ai-model" label={t("upload.image.useModel")} className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ai_model} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].ai_model).then(() => dialog("確認","AIモデルをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={9} sm={6} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].model_hash && modelVersion !== "" ? "block":"none"}}>
                                    <FloatingLabel controlId="model-version" label={t("upload.image.modelVersion")} className="mb-3">
                                        <Form.Control type="text" defaultValue={modelVersion} readOnly onClick={() => copyTextToClipboard(modelVersion).then(() => dialog("確認","モデルバージョンをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4} xl={1} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].steps && imageInfo.detail[detailNo].steps.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="steps" label="Steps" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].steps} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].steps).then(() => dialog("確認","Stepsをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={4} sm={4} md={4} lg={4} xl={1} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].scale && imageInfo.detail[detailNo].scale.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="scale" label="Scale" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].scale} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].scale).then(() => dialog("確認","Scaleをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].seed && imageInfo.detail[detailNo].seed.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="seed" label="Seed" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].seed} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].seed).then(() => dialog("確認","Seedをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].sampler && imageInfo.detail[detailNo].sampler.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="sampler" label="Sampler" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].sampler} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].sampler).then(() => dialog("確認","Sampleをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].strength && imageInfo.detail[detailNo].strength.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="strength" label="Strength" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].strength} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].strength).then(() => dialog("確認","Strengthをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].mask_blur && imageInfo.detail[detailNo].mask_blur.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="mask-blur" label="Mask blur" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].mask_blur} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].mask_blur).then(() => dialog("確認","Mask blurをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].clip_skip && imageInfo.detail[detailNo].clip_skip.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="clip-skip" label="Clip skip" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].clip_skip} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].clip_skip).then(() => dialog("確認","Clip Skipをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_enabled && imageInfo.detail[detailNo].controlnet_enabled.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="controlnet-enabled" label="ControlNet Enabled" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_enabled} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_enabled).then(() => dialog("確認","ControlNet Enabledをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_module && imageInfo.detail[detailNo].controlnet_module.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="controlnet-module" label="ControlNet Module" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_module} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_module).then(() => dialog("確認","ControlNet Moduleをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={8} sm={4} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_model && imageInfo.detail[detailNo].controlnet_model.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="controlnet-model" label="ControlNet Model" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_model} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_model).then(() => dialog("確認","ControlNet Modelをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_weight && imageInfo.detail[detailNo].controlnet_weight.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="controlnet-weight" label="ControlNet Weight" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].controlnet_weight} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].controlnet_weight).then(() => dialog("確認","ControlNet Weightをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ensd && imageInfo.detail[detailNo].ensd.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="ensd" label="ENSD" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].ensd} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].ensd).then(() => dialog("確認","ENSDをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscale && imageInfo.detail[detailNo].hires_upscale.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="hires-upscale" label="Hires Upscale" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscale} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].hires_upscale).then(() => dialog("確認","Hires Upscaleをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscaler && imageInfo.detail[detailNo].hires_upscaler.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="hires-upscaler" label="Hires Upscaler" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].hires_upscaler} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].hires_upscaler).then(() => dialog("確認","Hires Upscalerをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].raw_info && imageInfo.detail[detailNo].raw_info.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="raw-info" label="Raw Info" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].raw_info} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].raw_info).then(() => dialog("確認","Raw Infoをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={8} sm={8} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vae && imageInfo.detail[detailNo].vae.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="vae" label="VAE" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vae} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].vae).then(() => dialog("確認","VAEをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={8} sm={8} md={4} lg={4} xl={3} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].gpu && imageInfo.detail[detailNo].gpu.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="gpu" label="GPU" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].gpu} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].gpu).then(() => dialog("確認","GPUをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                                <Col xs={6} sm={4} md={4} lg={4} xl={2} style={{display: imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vram && imageInfo.detail[detailNo].vram.length > 0 ? "block":"none"}}>
                                    <FloatingLabel controlId="vram" label="VRAM" className="mb-3">
                                        <Form.Control type="text" defaultValue={imageInfo.detail[detailNo] && imageInfo.detail[detailNo].vram} readOnly onClick={() => copyTextToClipboard(imageInfo.detail[detailNo].vram).then(() => dialog("確認","VRAMをコピーしました。"))} style={{cursor:"pointer"}} />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                        </Container>
                    </Tab>
                    <Tab eventKey="other" title={t("common.otherPosts")}>
                            {userImageList.length > 0 ? (
                                <Container className='mt-3 mb-3 p-0'>
                                    <Container style={{width:"100%",height:"225px",maxHeight:"230px",padding:"5px",backgroundColor:"#FFFFFF",border:"1px solid #CCCCCC",borderRadius:"5px",overflow:"auto"}}>
                                        {userImageList.map((d,i) => {
                                            return (
                                                <div style={{position:"relative",float:"left"}} key={d.id}>
                                                    <div style={{width:"100px",height:"100px",overflow:"hidden"}} className="m-1">
                                                        <Image loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/text/post/t/"+d.id+ApiFetch.API_THUMB_EXT} style={{objectFit:"cover",width:"100%",height:"100%",cursor:"pointer",opacity:d.group_id === groupId ? "0.2" : ""}} onClick={() => {
                                                            setDetailNo(0)
                                                            navigate("/text/"+d.group_id)
                                                        }} />
                                                    </div>
                                                    {d.age_limit === 4 ? (<Badge bg="danger" className='m-1' style={{position:"absolute",top:"5px",left:"5px"}}> R-18</Badge>) : ""}
                                                    {d.age_limit === 5 ? (<Badge bg="danger" className='m-1' style={{position:"absolute",top:"5px",left:"5px"}}> R-18G</Badge>) : ""}
                                                </div>
                                            )
                                        })}
                                    </Container>
                                </Container>
                            ) : ""}
                        </Tab>
                </Tabs>
            </Container>
            : ""}
        </div>
        <Container style={{fontSize:"24px",fontWeight:"bold"}} className='mt-3 mb-3 p-0'>{t("")}</Container>
        <Container className='p-0 lazy' data-type='search'>
            <InputGroup className='m-2' style={{width:"280px"}}>
                <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={omitContinuous} onClick={(e) => {
                    updateRenzoku(e.currentTarget.checked ? "on" : "off")
                    setOmitContinuous(e.currentTarget.checked)
                    }} />
                    <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
            </InputGroup>
            <h3>#{tag}</h3>
        </Container>
        <Masonry
            breakpointCols={breakpointColumnsObj}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
            >
            {imageList.map((data,i) => {
                if(data.mute === 1 || (omitContinuous && i > 0 && imageList[i-1].user_id === data.user_id)){
                    return <span data-no={i} className="lazy-hidden" key={i}></span>
                }
                return <Tile type="text" data={data} i={i} dialog={dialog} key={i} observer={observer} />
            })}
        </Masonry>
        <Container className='mt-4 mb-3' style={{fontSize:"24px",fontWeight:"bold",display:"block",borderLeft:"10px solid lightblue",borderBottom:"3px solid lightblue"}}>
            <Icon.SortUpAlt style={{paddingBottom:"1px",color:"orange"}} /> {t("home.popularContributors")}
        </Container>
        <Container className='w-100 mb-3' style={{display:"block"}}>
            <Row>
            {last6MonthAvg.map((data,i) => {
            return <Col xs={5} sm={5} md={3} lg={2} xl={2} xxl={2} style={{margin:"0 auto",textAlign:"center",fontWeight:"bold"}} key={i}>
                        <UserAvatarWithLikes 
                            userId={data.user_id} 
                            size="100%" 
                            linkTo={"/user/"+(data.user_id)}
                        />
                        <LinkContainer to={"/user/"+(data.user_id)} style={{color:"#555555",textDecoration:"none",cursor:"pointer"}}><span>{data.user_name}</span></LinkContainer><br />
                        <FollowButton userId={data.user_id} />
                </Col>
            })}
            </Row>
        </Container>
        <Footer />
    </div>
    )}
}

export default TextView;
